const communicationPreferencesContent = {
  "The Glenrothes": {
    title: "Receive The Glenrothes Updates",
    copy: [
      "For generations, The Glenrothes has been synonymous with craftsmanship, tradition, and the finest whiskies from Speyside. Our story is one of passion, precision, and a deep connection to the land and people of Rothes.",
      "When you opt in, you'll become part of that story. You'll receive news on our latest whisky releases and exclusive launches. We'll send invitations to tastings, events, and experiences that celebrate The Glenrothes. And you'll gain insight into The Spirit of Rothes, the philosophy, the craftsmanship, and the heritage that define who we are.",
      "Our communications are designed to enrich your connection to The Glenrothes, whether you're new to whisky or a seasoned enthusiast. Everything arrives via email, so you can enjoy and reflect on each message at your leisure."
    ],
    optInText: "Would you like to receive updates from The Glenrothes?",
    privacyLink: "privacy-policy",
    optInAPI: {
      our_whisky_and_new_releases: true,
      events_and_experiences: true,
      the_spirit_of_rothes: true,
      region_north_america: false,
      region_south_america: false,
      region_prc: false,
      region_taiwan: false,
      region_singapore: false,
      region_nordics: false,
      region_uk: false,
      region_rest_of_europe: false,
      interest_personal: false,
      interest_media: false,
      interest_trade: false
    },
    optOutAPI: {
      our_whisky_and_new_releases: false,
      events_and_experiences: false,
      the_spirit_of_rothes: false,
      region_north_america: false,
      region_south_america: false,
      region_prc: false,
      region_taiwan: false,
      region_singapore: false,
      region_nordics: false,
      region_uk: false,
      region_rest_of_europe: false,
      interest_personal: false,
      interest_media: false,
      interest_trade: false
    }
  },
  "Highland Park": {
    title: "Join the Highland Park Circle",
    copy: [
      "We believe the best experiences are shared. By opting in, you'll be part of the Highland Park community and receive carefully curated updates about our whiskies, distillery stories, the magic of Orkney, recipes and food pairings, and exclusive invitations to events and tastings.",
      "Whether you're discovering single malts for the first time or you're a devoted Highland Park enthusiast, we'll share what matters most to you, from new releases and limited editions to behind-the-scenes insights from our pagoda roofs to our malting room floor, and the people who craft our whisky.",
      "All communications will arrive via email, keeping you connected without overwhelming your inbox."
    ],
    optInText: "Would you like to hear from Highland Park?",
    privacyLink: "privacy-cookies-policy",
    optInAPI: {
      our_whisky: true,
      our_distillery: true,
      our_orkney_islands_home: true,
      recipes_and_food_pairings: false,
      events_and_experiences: false,
      region_australia: false,
      region_belgium: false,
      region_canada: false,
      region_china: false,
      region_denmark: false,
      region_finland: false,
      region_france: false,
      region_germany: false,
      region_hong_kong: false,
      region_netherlands: false,
      region_norway: false,
      region_russia: false,
      region_sweden: false,
      region_taiwan: false,
      region_uk: false,
      region_us: false,
      comm_email: true,
      comm_sms: false,
      comm_post: false,
      experience_new_to_single_malts: false,
      experience_new_to_highland_park: false,
      experience_tried_highland_park_before: false,
      experience_regularly_drink_highland_park: false,
      experience_highland_park_is_my_favourite_whisky: false
    },
    optOutAPI: {
      our_whisky: false,
      our_distillery: false,
      our_orkney_islands_home: false,
      recipes_and_food_pairings: false,
      events_and_experiences: false,
      region_australia: false,
      region_belgium: false,
      region_canada: false,
      region_china: false,
      region_denmark: false,
      region_finland: false,
      region_france: false,
      region_germany: false,
      region_hong_kong: false,
      region_netherlands: false,
      region_norway: false,
      region_russia: false,
      region_sweden: false,
      region_taiwan: false,
      region_uk: false,
      region_us: false,
      comm_email: false,
      comm_sms: false,
      comm_post: false,
      experience_new_to_single_malts: false,
      experience_new_to_highland_park: false,
      experience_tried_highland_park_before: false,
      experience_regularly_drink_highland_park: false,
      experience_highland_park_is_my_favourite_whisky: false
    }
  }
};

export default communicationPreferencesContent;
